import React, { useState } from 'react';
import { Dialog, Typography, Button, Box, Stack, CardHeader, Paper } from '@mui/material';
import { gql, useQuery } from '@apollo/client';
import onboardingExample from './onboarding_example.png';

const FEATURE_ONBOARDING_CHECK = gql`
  query featureOnboarding($featureName: String!) {
    featureOnboardingStatus(featureName: $featureName)
  }
`;

const OnboardingModal: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  useQuery(FEATURE_ONBOARDING_CHECK, {
    variables: { featureName: 'SimpleDiagnosisSelection' },
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data?.featureOnboardingStatus === 'UNKNOWN') {
        setOpen(true);
      }
    },
  });

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" data-testid="onboarding-modal">
      <Stack>
        {/* Diagnosis Selection Preview */}
        <Stack
          sx={{
            backgroundColor: 'action.selected',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 5,
            width: '759px',
          }}>
          <Paper sx={{ width: '340px' }}>
            <img
              src={onboardingExample}
              alt="Diagnosis selection example"
              style={{
                maxWidth: '100%',
                height: 'auto',
                borderRadius: '4px',
              }}
            />
          </Paper>
        </Stack>

        {/* Welcome Message */}
        <CardHeader sx={{ textAlign: 'center' }} title={'Welcome to the new diagnosis selection page!'} />

        <Typography variant="subtitle1" align="center" color="secondary.dark" gutterBottom>
          What's changed?
        </Typography>

        <Typography variant="body2" align="center" color="text.secondary" gutterBottom>
          1. Streamlined experience to save time and reduce clicks
        </Typography>
        <Typography variant="body2" align="center" color="text.secondary" gutterBottom>
          2. New diagnosis selection tables display ICD10 codes and descriptions
        </Typography>
        <Typography variant="body2" align="center" color="text.secondary" gutterBottom>
          3. New statuses and filters to narrow down search results
        </Typography>

        {/* Close Button */}
        <Box display="flex" justifyContent="flex-end" sx={{ padding: 2 }}>
          <Button size="small" variant="text" onClick={() => setOpen(false)}>
            GOT IT!
          </Button>
        </Box>
      </Stack>
    </Dialog>
  );
};

export default OnboardingModal;
